<template>
    <div class="head">

        <img class="logo" src="../../images/logo.svg" title="回到首页" @click="backHome" />

        <ul @click="openPage">
            <li id="home" :class="{'active': current == 0}" title="首页">首页</li>
            <li id="news" :class="{'active': current == 1}" title="开源资讯">开源资讯</li>
            <li id="project" :class="{'active': current == 2}" title="开源项目">开源项目</li>
            <li id="about" :class="{'active': current == 3}" title="关于">关于</li>
        </ul>
        <span class="org-url">
            <a class="gitee" href="https://gitee.com/baidu" target="_Blank">
                <img src="../../images/Gitee.svg" title="百度开源-gitee" />
            </a>
            <a class="github" href="https://github.com/baidu" target="_Blank">
                <img src="../../images/Github.svg" title="百度开源-github" />
            </a>
        </span>
    </div>
</template>
<script>
    export default {
        props: ['current'],
        methods: {
            openPage(e) {
                let id = e.target.id;
                if (id) {
                    switch (id) {
                        case "home": {
                            this.$router.push({name: 'Homepage'})
                        } break;
                        case "news": {
                            this.$router.push({name: 'NewsList'})
                        } break;
                        case "project": {
                            this.$router.push({name: 'ProjectsList'})
                        } break;
                        case "about": {
                            this.$router.push({name: 'About'})
                        } break;
                        default: break;
                    }
                }
            },

            // 回到首页
            backHome() {
                this.$router.push({name: 'Homepage'})
            }
        },
    }
</script>
<style lang="less" scoped>
    .head {
        height: 80px;
        width: 1320px;
        margin: 0 auto;

        .logo {
            height: 40px;
            float: left;
            padding: 0;
            padding-top: 10px;
            padding-bottom: 30px;
            cursor: pointer;
        }

        ul {
            display: inline-block;
            margin-left: 100px;
            height: 80px;
            line-height: 77px;

            li {
                list-style-type: none;
                float: left;
                width: 150px;
                text-align: center;
                font-size: 18px;
                margin-left: 20px;
            }

            li:hover {
                cursor: pointer;
                color: #043484;
                font-weight: bold;
                border-bottom: 2px solid #043484;
            }
        }

        .active {
            color: #043484;
            font-weight: bold;
        }

        .org-url {
            float: right;
            padding: 25px;
            padding-right: 0;
            margin-right: 0;
            a {
                margin-left: 16px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/common/head-menu/index.vue